import { render, staticRenderFns } from "./MyReferralsList.vue?vue&type=template&id=598954f7&"
import script from "./MyReferralsList.vue?vue&type=script&lang=ts&"
export * from "./MyReferralsList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports